import React, { useEffect, useState } from "react";
import fallbackImage from "../assets/zeamays.png";

const normalizeImageSrc = (value) => {
  const trimmed = String(value || "").trim();

  if (!trimmed) {
    return fallbackImage;
  }

  if (/^(https?:|data:)/i.test(trimmed) || trimmed.startsWith("/")) {
    return trimmed;
  }

  return trimmed;
};

const ProductImage = ({ src, alt, className = "", fit = "cover", ...props }) => {
  const [imageSrc, setImageSrc] = useState(() => normalizeImageSrc(src));

  useEffect(() => {
    setImageSrc(normalizeImageSrc(src));
  }, [src]);

  const objectFit = fit === "contain" ? "contain" : "cover";

  return (
    <img
      {...props}
      src={imageSrc}
      alt={alt}
      className={["block", "h-full", "w-full", "max-w-full", className, objectFit === "contain" ? "object-contain" : "object-cover"].filter(Boolean).join(" ")}
      style={{ objectFit, objectPosition: "center" }}
      onError={() => {
        if (imageSrc !== fallbackImage) {
          setImageSrc(fallbackImage);
        }
      }}
    />
  );
};

export default ProductImage;
